<template>
    <footer class="checker-page-footer">
        <span>© 2020 - Mind Lens Worldwide</span>
    </footer>
</template>

<script>
export default {
    name: "CheckerPageFooter"
}
</script>

<style lang="scss" scoped>
.checker-page-footer {
    background: $color-footer;
    padding: rem(22);
    display: flex;
    justify-content: center;
    @include font-size(s);
    color: $color-black;
}
</style>